module.exports = __webpack_public_path__ + "static/media/Logo__SHPE.7cbc1622.svg";